"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NChangedProduct_1 = require("../model/NChangedProduct");

var NChangedProductConverter_1 = require("./NChangedProductConverter");
/**
 * @author Tomas Leity
 */


var NChangedProductConverterImpl =
/*#__PURE__*/
function (_NChangedProductConve) {
  _inherits(NChangedProductConverterImpl, _NChangedProductConve);

  function NChangedProductConverterImpl() {
    _classCallCheck(this, NChangedProductConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedProductConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedProductConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedProduct_1.NChangedProduct(NChangedProduct_1.NChangedProduct.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NChangedProduct_1.NChangedProduct.schema.productName.valueOf(source.productName), NChangedProduct_1.NChangedProduct.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), NChangedProduct_1.NChangedProduct.schema.systemVolume.valueOf(conversions.toBigNumber(source.systemVolume)), NChangedProduct_1.NChangedProduct.schema.state.valueOf(conversions.asEnum(source.state, NChangedProduct_1.NChangedProductState)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        systemVolume: conversions.fromBigNumber(source.systemVolume),
        state: source.state
      });
      return result;
    }
  }]);

  return NChangedProductConverterImpl;
}(NChangedProductConverter_1.NChangedProductConverter);

exports.NChangedProductConverterImpl = NChangedProductConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedProductConverterImpl.QUALIFIER = {
  documentType: NChangedProduct_1.NChangedProduct.name
};